<!-- 远程设置 -->
<template>
  <div class="app-container">
    <div class="app-content">
      <el-card class="energy-remote" shadow="never">
        <template slot="header">
          <el-form inline size="small">
            <el-form-item :label="$t('text.nbqxlh')">
              <el-input
                v-model="queryParams.sn"
                clearable
                :placeholder="$t('placeholder.srnbq')"
              />
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="handleQuery"
              >{{ $t('button.cx') }}</el-button>
            </el-form-item>
          </el-form>
        </template>
        <template flot="default">
          <el-table
            v-loading="loading"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
            :data="tableData"
            height="calc(100% - 50px)"
            style="width: 100%"
          >
            <template slot="empty">
              <div class="table-no-data" />
            </template>
            <el-table-column
              align="center"
              width="80px"
              type="index"
              :index="indexCount"
              :label="$t('text.xh')"
            />
            <el-table-column
              align="center"
              :label="$t('text.nbqxlh')"
              prop="sn"
              :formatter="$elFormatter"
            />
            <el-table-column
              align="center"
              :label="$t('text.nbqbm')"
              prop="ialias"
              show-overflow-tooltip
              :formatter="$elFormatter"
            />
            <el-table-column
              align="center"
              :label="$t('text.cz')"
            >
              <template v-slot="scope">
                <el-button size="small" type="text" icon="el-icon-setting" @click="handleParamSet(scope.row)">{{ $t('button.cssz') }}</el-button>
                <el-button size="small" type="text" icon="el-icon-date" @click="handleTimeSet(scope.row)">{{ $t('button.sjsz') }}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            :current-page.sync="pageNum"
            :page-size="pageSize"
            :total="total"
            background
            layout="total, prev, pager, next"
            @current-change="getTableData"
          />
        </template>
      </el-card>
      <!-- 时间设置弹框 -->
      <el-dialog
        :visible.sync="timeShow"
        :title="$t('button.sjsz')"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        append-to-body
      >
        <el-form label-width="120px">
          <el-form-item :label="$t('text.shijian')">
            <el-date-picker v-model="timeDetail.time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" />
          </el-form-item>
          <!-- <el-form-item label="星期">
            <el-select v-model="timeDetail.week" disabled>
              <el-option v-for="item in week" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item> -->
        </el-form>
        <div slot="footer">
          <el-button type="primary" plain @click="handleChangeTime">{{ $t('button.qd') }}</el-button>
          <el-button type="info" plain @click="timeShow=false">{{ $t('button.qx') }}</el-button>
        </div>
      </el-dialog>
      <!-- 参数设置弹框 -->
      <el-dialog
        custom-class="show-dialog-set"
        :title="$t('button.cssz')"
        :visible.sync="paramShow"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        append-to-body
      >
        <el-scrollbar style="height:100%">
          <el-form ref="paramForm" label-width="140px" :model="paramDetail" :rules="{}">
            <el-row>
              <el-col :span="12">
                <el-form-item :label="$t('param.gzms')">
                  <el-select v-model="paramDetail.workMode">
                    <el-option :label="$t('param.zfzy')" value="0" />
                    <el-option :label="$t('param.xftg')" value="1" />
                    <el-option :label="$t('param.dcyx')" value="2" />
                  </el-select>
                </el-form-item></el-col>
              <el-col :span="12">
                <el-form-item :label="$t('param.dcfdsd')" prop="depthOfDischarge">
                  <el-input v-model="paramDetail.depthOfDischarge">
                    <template slot="append">%</template>
                  </el-input>
                </el-form-item></el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item :label="$t('param.dccddl')" prop="iCharge">
                  <el-input v-model="paramDetail.iCharge" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('param.bwgldd')" prop="gridPowerScheduling">
                  <el-input v-model="paramDetail.gridPowerScheduling">
                    <template slot="append">%</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item :label="$t('param.dcfdgldd')" prop="dischargePowerScheduling">
                  <el-input v-model="paramDetail.dischargePowerScheduling">
                    <template slot="append">%</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('param.glys')" prop="fac">
                  <el-input v-model="paramDetail.fac" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item :label="$t('param.wggl')" prop="reactPower">
                  <el-input v-model="paramDetail.reactPower" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('param.dwdyxx')" prop="vacL">
                  <el-input v-model="paramDetail.vacL" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item :label="$t('param.dwdysx')" prop="vacU">
                  <el-input v-model="paramDetail.vacU" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('param.dwplxx')" prop="frqL">
                  <el-input v-model="paramDetail.frqL" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item :label="$t('param.dwplsx')" prop="frqU">
                  <el-input v-model="paramDetail.frqU" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('param.dctxfs')">
                  <el-select v-model="paramDetail.communication">
                    <el-option label="CAN" value="1" />
                    <el-option label="485" value="2" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item :label="$t('param.yy')">
                  <el-select v-model="paramDetail.language">
                    <el-option :label="$t('param.zw')" value="1411" />
                    <el-option :label="$t('param.yw')" value="1422" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('param.fnl')">
                  <el-select v-model="paramDetail.backflowPrevent">
                    <el-option :label="$t('param.jz')" value="0" />
                    <el-option :label="$t('param.yx')" value="1" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item :label="$t('param.pvsrlx')">
                  <el-select v-model="paramDetail.pvInCatgroy">
                    <el-option :label="$t('param.dl')" value="0" />
                    <el-option :label="$t('param.bl')" value="1" />
                    <el-option :label="$t('param.hy')" value="2" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('param.dclx')">
                  <el-select v-model="paramDetail.batteryCatgroy">
                    <el-option :label="$t('param.zly')" value="0" />
                    <el-option :label="$t('param.qsdc')" value="1" />
                    <el-option :label="$t('param.ldc')" value="2" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item :label="$t('param.dccddy')" prop="vbCharge">
                  <el-input v-model="paramDetail.vbCharge" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('param.pvgldd')" prop="pvPowerScheduling">
                  <el-input v-model="paramDetail.pvPowerScheduling">
                    <template slot="append">%</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item :label="$t('param.dccdbhdy')" prop="vbChargePrevent">
                  <el-input v-model="paramDetail.vbChargePrevent" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('param.gjdwbz')">
                  <el-select v-model="paramDetail.gridStandard">
                    <el-option :label="$t('param.az')" value="0" />
                    <el-option :label="$t('param.azx')" value="1" />
                    <el-option :label="$t('param.xxl')" value="2" />
                    <el-option :label="$t('param.yg')" value="3" />
                    <el-option :label="$t('param.dg')" value="4" />
                    <el-option :label="$t('param.hg')" value="5" />
                    <el-option :label="$t('param.flb')" value="6" />
                    <el-option :label="$t('param.zg')" value="7" />
                    <el-option :label="$t('param.mg')" value="8" />
                    <el-option :label="$t('param.tg')" value="9" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-scrollbar>
        <div slot="footer">
          <el-button type="primary" plain @click="handleChangeParam">{{ $t('button.qd') }}</el-button>
          <el-button type="info" plain @click="paramShow=false">{{ $t('button.qx') }}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { QueryStationReal } from '@apis/Stations'
import { GetSettingArguments, GetInverterTime, UpdateInverterArguments,
  UpdateInverterTime } from '@apis/Device'
import { removeEqParams } from '@utils'
export default {
  components: {

  },
  data () {
    const depthOfDischarge = (rule, value, callback) => {
      if (Number(this.paramDetail.depthOfDischarge) >= 10 && Number(this.paramDetail.depthOfDischarge) <= 90) {
        callback()
      } else {
        callback('只能输入10 ~ 90')
      }
    }
    const iCharge = (rule, value, callback) => {
      if (Number(this.paramDetail.iCharge) >= 1 && Number(this.paramDetail.iCharge) <= 95) {
        callback()
      } else {
        callback('只能输入1 ~ 95')
      }
    }
    const gridPowerScheduling = (rule, value, callback) => {
      if (Number(this.paramDetail.gridPowerScheduling) >= 0 && Number(this.paramDetail.gridPowerScheduling) <= 100) {
        callback()
      } else {
        callback('只能输入0 ~ 100')
      }
    }
    const dischargePowerScheduling = (rule, value, callback) => {
      if (Number(this.paramDetail.dischargePowerScheduling) >= 0 && Number(this.paramDetail.dischargePowerScheduling) <= 10) {
        callback()
      } else {
        callback('只能输入0 ~ 10')
      }
    }
    const fac = (rule, value, callback) => {
      if (Number(this.paramDetail.fac) >= -1 && Number(this.paramDetail.fac) <= -0.8 || Number(this.paramDetail.fac) >= 0.8 && Number(this.paramDetail.fac) <= 1) {
        callback()
      } else {
        callback('只能输入-1 ~ -0.8 或 0.8 ~ 1')
      }
    }
    const reactPower = (rule, value, callback) => {
      if (Number(this.paramDetail.reactPower) >= -60 && Number(this.paramDetail.reactPower) <= 60) {
        callback()
      } else {
        callback('只能输入-60 ~ 60')
      }
    }
    const vacL = (rule, value, callback) => {
      if (Number(this.paramDetail.vacL) >= 150 && Number(this.paramDetail.vacL) <= 220) {
        callback()
      } else {
        callback('只能输入150 ~ 220')
      }
    }
    const vacU = (rule, value, callback) => {
      if (Number(this.paramDetail.vacU) >= 240 && Number(this.paramDetail.vacU) <= 280) {
        callback()
      } else {
        callback('只能输入240 ~ 280')
      }
    }
    const frqL = (rule, value, callback) => {
      if (Number(this.paramDetail.frqL) >= 45 && Number(this.paramDetail.frqL) <= 50.20) {
        callback()
      } else {
        callback('只能输入45 ~ 50.20')
      }
    }
    const frqU = (rule, value, callback) => {
      if (Number(this.paramDetail.frqU) >= 50.20 && Number(this.paramDetail.frqU) <= 65) {
        callback()
      } else {
        callback('只能输入50.20 ~ 65')
      }
    }
    const vbCharge = (rule, value, callback) => {
      if (Number(this.paramDetail.vbCharge) >= 135 && Number(this.paramDetail.vbCharge) <= 351) {
        callback()
      } else {
        callback('只能输入135 ~ 351')
      }
    }
    const pvPowerScheduling = (rule, value, callback) => {
      if (Number(this.paramDetail.pvPowerScheduling) >= 0 && Number(this.paramDetail.pvPowerScheduling) <= 100) {
        callback()
      } else {
        callback('只能输入0 ~ 100')
      }
    }
    const vbChargePrevent = (rule, value, callback) => {
      if (Number(this.paramDetail.vbChargePrevent) >= 141 && Number(this.paramDetail.vbChargePrevent) <= 360) {
        callback()
      } else {
        callback('只能输入141 ~ 360')
      }
    }
    return {
      week: [
        { label: '日', value: '0' },
        { label: '一', value: '1' },
        { label: '二', value: '2' },
        { label: '三', value: '3' },
        { label: '四', value: '4' },
        { label: '五', value: '5' },
        { label: '六', value: '6' },
      ],
      queryParams: {
        stationid: this.$store.getters.station.id
      },
      rules: {
        depthOfDischarge: [
          { validator: depthOfDischarge, trigger: 'blur' }
        ],
        iCharge: [
          { validator: iCharge, trigger: 'blur' }
        ],
        gridPowerScheduling: [
          { validator: gridPowerScheduling, trigger: 'blur' }
        ],
        dischargePowerScheduling: [
          { validator: dischargePowerScheduling, trigger: 'blur' }
        ],
        fac: [
          { validator: fac, trigger: 'blur' }
        ],
        reactPower: [
          { validator: reactPower, trigger: 'blur' }
        ],
        vacL: [
          { validator: vacL, trigger: 'blur' }
        ],
        vacU: [
          { validator: vacU, trigger: 'blur' }
        ],
        frqL: [
          { validator: frqL, trigger: 'blur' }
        ],
        frqU: [
          { validator: frqU, trigger: 'blur' }
        ],
        vbCharge: [
          { validator: vbCharge, trigger: 'blur' }
        ],
        pvPowerScheduling: [
          { validator: pvPowerScheduling, trigger: 'blur' }
        ],
        vbChargePrevent: [
          { validator: vbChargePrevent, trigger: 'blur' }
        ],
      },
      loading: false,
      tableData: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      paramShow: false,
      paramDetail: {},
      timeShow: false,
      timeDetail: {},
      selectId: '', // 选中的设置id
      fullLoading: null,
      oldParams: {}, // 原始属性值
    }
  },
  mounted () {
    this.getTableData()
  },
  methods: {
    // 序号
    indexCount (index) {
      return (this.pageNum - 1) * this.pageSize + (index + 1)
    },
    // 查询
    handleQuery () {
      this.pageNum = 1
      this.getTableData()
    },
    // 获取表格数据
    getTableData () {
      this.loading = true
      QueryStationReal({
        page: this.pageNum,
        perPage: this.pageSize,
        orderBy: 'sn',
        whereCondition: JSON.stringify(this.queryParams)
      })
        .then(res => {
          this.tableData = res.data.queryResults
          this.total = res.data.totalCount
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 属性弹框
    handleParamSet (row) {
      this.fullLoading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.selectId = row.devid
      GetSettingArguments({
        id: row.devid
      })
        .then(res => {
          this.paramDetail = res.data
          this.oldParams = this.$deepClone(res.data)
          this.paramShow = true
          this.$refs.paramForm.clearValidate()
          this.fullLoading.close()
        })
        .catch(() => {
          this.fullLoading.close()
        })
    },
    // 时间弹框
    handleTimeSet (row) {
      this.fullLoading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.selectId = row.devid
      GetInverterTime({
        id: row.devid
      })
        .then(res => {
          this.timeDetail = res.data
          this.timeShow = true
          this.fullLoading.close()
        })
        .catch(() => {
          this.fullLoading.close()
        })
    },
    // 设置参数
    handleChangeParam () {
      this.$refs.paramForm.validate((valid, object) => {
        if (valid) {
          const data = this.$deepClone(this.paramDetail)
          const obj = removeEqParams(this.oldParams, data)
          UpdateInverterArguments({
            id: this.selectId,
            args: obj
          })
            .then(() => {
              this.$msgSuccess(this.$t('notice.xgcg'))
              this.paramShow = false
            })
        }
      })
    },
    // 设置时间
    handleChangeTime () {
      UpdateInverterTime({
        id: this.selectId,
        tag: this.timeDetail.time
      })
        .then(() => {
          this.$msgSuccess(this.$t('notice.xgcg'))
          this.timeShow = false
        })
    }
  }
}
</script>
<style scoped>
.energy-remote {
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  background-color: var(--card-bg-color);
  border-color: var(--card-bg-color);
}
.energy-remote>>> .el-card__header {
  width: 100%;
  height: 50px;
  padding: 0 20px;
  box-sizing: border-box;
}
.energy-remote>>> .el-card__header .el-form{
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.energy-remote>>> .el-card__header .el-form .el-form-item{
  margin-bottom: 0;
}

.energy-remote>>> .el-card__body {
  width: 100%;
  height: calc(100% - 50px);
  padding: 0 20px;
  box-sizing: border-box;
}
.energy-remote>>> .el-card__body .el-table {
  border: none;
}
.energy-remote>>> .el-card__body .el-pagination {
  width: 100%;
  height: 50px;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.energy-remote>>> .el-card__body .el-table--border::after, .el-table--group::after, .el-table::before{
  background-color: transparent;
}
</style>
